import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Form, Input } from "antd";
import { isHost, isUrl } from "@devowl-wp/react-utils";
import { useI18n } from "../../../../../../../contexts/i18n.js";
import { Notices } from "../../../../../../common/notices.js";
import { FormServiceFieldTechnicalDefinitionsLayout } from "../table.js";
const FormServiceFieldTechnicalDefinitionsCookieHost = ({ field, readOnly })=>{
    const { __, _i } = useI18n();
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsx(Form.Item, {
            noStyle: true,
            shouldUpdate: (prevValues, nextValues)=>prevValues.technicalDefinitions[field.name]?.type !== nextValues.technicalDefinitions[field.name]?.type || prevValues.technicalDefinitions[field.name]?.host !== nextValues.technicalDefinitions[field.name]?.host,
            children: ({ getFieldValue })=>{
                const type = getFieldValue([
                    "technicalDefinitions",
                    field.name,
                    "type"
                ]);
                const host = getFieldValue([
                    "technicalDefinitions",
                    field.name,
                    "host"
                ]);
                return /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(Form.Item, {
                            ...FormServiceFieldTechnicalDefinitionsLayout,
                            name: [
                                field.name,
                                "host"
                            ],
                            rules: [
                                {
                                    validator: (_, value)=>([
                                            "local",
                                            "session",
                                            "indexedDb"
                                        ].indexOf(type) > -1 ? isUrl(value) : isHost(value)) || value === "" && type !== "http" ? Promise.resolve() : Promise.reject(__("Please provide a valid hostname!"))
                                }
                            ],
                            dependencies: [
                                [
                                    "technicalDefinitions",
                                    field.name,
                                    "type"
                                ]
                            ],
                            children: /*#__PURE__*/ _jsx(Input, {
                                disabled: readOnly
                            })
                        }),
                        host.startsWith("*.") && host.length > 2 && /*#__PURE__*/ _jsx(Notices, {
                            notices: [
                                {
                                    message: _i(__("You are using an invalid wildcard (placeholder) syntax {{code}}*.{{/code}} to match subdomains. Use {{code}}.%s{{/code}} to include subdomains.", host.substr(2)), {
                                        code: /*#__PURE__*/ _jsx("code", {})
                                    }),
                                    severity: "warning"
                                }
                            ]
                        })
                    ]
                });
            }
        })
    });
};
export { FormServiceFieldTechnicalDefinitionsCookieHost };
